import React, { useState, useEffect } from "react";
import toast from "react-hot-toast";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

// Components
import Layout from "../../../../Layout/Layout";
import { InputField } from "../../../../Components/formElements/InputField";
import DataTable from "react-data-table-component";
import SuccessRegisterModal from "../../../../Components/SuccessRegisterModal";
import Constants from "../../../../common/SupplierConstants";
import FailureModal from "../../../../Components/Modal/supplier_app/FailureModal";
import CommonItemLevelDatatableModal from "../../../../Components/Modal/supplier_app/CommonItemLevelDatatableModal";
import EstimateModal from "./EstimateModal";
import { getTodayDate } from "../../../../common/Validations";
import EstimateMaterialSelectionModal from "./EstimateMaterialSelectionModal";

/** ──────────────────────────────────────────────
 * Material Catalog (replace with API later)
 * ──────────────────────────────────────────────*/
const MATERIAL_CATALOG = [
  {
    code: "BUW5",
    description: "BUILTUP WEB PLATE 5MM",
    unit: "M",
    unitWeight: 19.625,
    pieceWeight: 117.75,
    unitPrice: 100,
    unitWeightModifier: 1,
  },
  {
    code: "BUF8",
    description: "BUILTUP FLANGE PLATE 8MM",
    unit: "M",
    unitWeight: 9.42,
    pieceWeight: 56.52,
    unitPrice: 100,
    unitWeightModifier: 1,
  },
];

const num = (v) =>
  v === "" || v === null || v === undefined ? 0 : Number(v) || 0;

const CustomerEstimationE1 = () => {
  const modalData = { title: "Auction Creation", successMsg: "" };
  const [isCardVisible6, setCardVisible6] = useState(true);
  // eslint-disable-next-line
  const toggleCardVisibility6 = () => setCardVisible6(!isCardVisible6);
  const [getModalInfo] = useState(modalData);
  const [getShowSuccessModal, setShowSuccessModal] = useState(false);
  const [disabled, setDisabled] = useState(false);

  const hideSuccessModal = () => setShowSuccessModal(false);

  const failureModalData = { title: "Warning", ErrorMsg: "" };
  const [getShowFailureModal, setShowFailureModal] = useState(false);
  const [getErrorFields] = useState([]);
  const [getFailureModal] = useState(failureModalData);

  const hideFailureModal = () => setShowFailureModal(false);

  /* submit button */
  const handleCreateManualRFQ = async () => {
    setDisabled(true);
    // your submit logic here
  };

  useEffect(() => {
    localStorage.setItem("menu", "");
    localStorage.setItem("submenu", "");
  }, []);

  const [selectedOption, setSelectedOption] = useState("");
  const [blocks, setBlocks] = useState([
    {
      id: Date.now(),
      title: "Roof #1",
      getProductDetailsData: [],
      isVisible: true,
    },
  ]);

  const [activeBlockIndex, setActiveBlockIndex] = useState(null);

  const options = [
    "Roof #1",
    "Roof #2",
    "Near SideWall",
    "Far Side Wall",
    "Left End wall",
    "Right End wall",
  ];

  const handleChange = (e) => setSelectedOption(e.target.value);

  const handleAddBlock = () => {
    if (!selectedOption) return;
    const newBlock = {
      id: Date.now(),
      title: selectedOption,
      getProductDetailsData: [],
      isVisible: true,
    };
    setBlocks((prev) => [...prev, newBlock]);
    setSelectedOption("");
  };

  const toggleBlockVisibility = (blockIndex) => {
    setBlocks((prevBlocks) =>
      prevBlocks.map((block, index) =>
        index === blockIndex ? { ...block, isVisible: !block.isVisible } : block
      )
    );
  };

  /** Helpers */
  const makeBlankRow = (block) => ({
    local_id: block.getProductDetailsData.length + 1,
    materialCode: "",
    materialLongText: "",
    uOM: "",
    unitWeight: "",
    pieceWeight: "",
    quantity: "",
    pieceMeasurement: "",
    unitPrice: "",
    totalWeight: "",
    price: "",
    totalPrice: "",
    unitValue: "",
    accOnOff: false,
    orderQuantityLoad: "",
    dispatchDate: getTodayDate(""),
    orderStatus: "Pending",
  });

  const recalcDerived = (row) => {
    const totalWeight = num(row.pieceWeight) * num(row.pieceMeasurement);
    const price = num(row.pieceWeight) * num(row.unitPrice);
    const totalPrice = totalWeight * num(row.unitPrice);
    return {
      ...row,
      totalWeight: totalWeight ? Number(totalWeight.toFixed(2)) : "",
      price: price ? Number(price.toFixed(2)) : "",
      totalPrice: totalPrice ? Number(totalPrice.toFixed(2)) : "",
    };
  };

  /** Add empty row on + */
  const addEmptyRow = (blockIndex) => {
    setBlocks((prev) =>
      prev.map((b, i) =>
        i === blockIndex
          ? {
              ...b,
              getProductDetailsData: [
                ...b.getProductDetailsData,
                makeBlankRow(b),
              ],
            }
          : b
      )
    );
  };

  /** When user types/changes Material Code => autofill */
  const handleMaterialCodeChange = (blockIndex, local_id, codeInput) => {
    const code = (codeInput || "").toUpperCase().trim();
    setBlocks((prev) =>
      prev.map((b, i) => {
        if (i !== blockIndex) return b;
        const updated = b.getProductDetailsData.map((row) => {
          if (row.local_id !== local_id) return row;

          const match = MATERIAL_CATALOG.find((m) => m.code === code);
          if (!match) {
            return recalcDerived({
              ...row,
              materialCode: codeInput,
              materialLongText: "",
              uOM: "",
              unitWeight: "",
              pieceWeight: "",
              unitPrice: "",
              totalWeight: "",
              price: "",
              totalPrice: "",
              unitValue: "",
            });
          }
          return recalcDerived({
            ...row,
            materialCode: match.code,
            materialLongText: match.description,
            uOM: match.unit,
            unitWeight: match.unitWeight,
            pieceWeight: match.pieceWeight,
            unitPrice: match.unitPrice,
            unitValue: match.unitWeightModifier,
          });
        });
        return { ...b, getProductDetailsData: updated };
      })
    );
  };

  /** Generic inputs (quantity, pieceMeasurement, unitPrice, …) */
  const handleInputChange = (blockIndex, local_id, event, type) => {
    const { name, value } = event.target;
    if (type === "Number" && value !== "" && isNaN(value)) {
      toast.error("Please enter a valid number");
      return;
    }
    setBlocks((prev) =>
      prev.map((b, i) => {
        if (i !== blockIndex) return b;
        const updated = b.getProductDetailsData.map((row) =>
          row.local_id === local_id
            ? recalcDerived({ ...row, [name]: value })
            : row
        );
        return { ...b, getProductDetailsData: updated };
      })
    );
  };

  /** Delete only inside that block */
  const removeProductDetails = (blockIndex, local_id) => {
    setBlocks((prev) =>
      prev.map((b, i) => {
        if (i !== blockIndex) return b;
        const filtered = b.getProductDetailsData
          .filter((r) => r.local_id !== local_id)
          .map((r, idx) => ({ ...r, local_id: idx + 1 }));
        return { ...b, getProductDetailsData: filtered };
      })
    );
  };

  /** Handle selection from Modal → save into correct block */
  const handleGetSelectedMaterial = (selectedData, blockIndex) => {
    setBlocks((prev) =>
      prev.map((b, i) => {
        if (i !== blockIndex) return b;
        const merged = [
          ...b.getProductDetailsData,
          ...selectedData.map((item, idx) => ({
            local_id: b.getProductDetailsData.length + idx + 1,
            materialCode: item.code || "",
            materialLongText: item.description || "",
            uOM: item.unit || "",
            unitWeight: item.unitWeight || "",
            pieceWeight: item.pieceWeight || "",
            quantity: item.quantity || "",
            pieceMeasurement: item.pieceMeasure || "",
            unitPrice: item.unitPrice || "",
            totalWeight: item.totalWeight || "",
            price: item.price || "",
            totalPrice: item.totalPrice || "",
            unitValue: item.unitWeightModifier || "",
            accOnOff: false,
            orderQuantityLoad: "",
            dispatchDate: getTodayDate(""),
            orderStatus: "Pending",
          })),
        ];

        return {
          ...b,
          getProductDetailsData: merged.map((row, idx) => ({
            ...row,
            local_id: idx + 1,
          })),
        };
      })
    );
  };

  /** Columns per block */
  const getProductDetailsCol = (blockIndex) => [
    {
      name: "Sl.No",
      selector: (row) => row.local_id || "--",
      cell: (row) => <>{row.local_id}.</>,
      width: "80px",
    },
    {
      name: "Material Code",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="materialCode"
          value={row.materialCode || ""}
          onChange={(e) =>
            handleMaterialCodeChange(blockIndex, row.local_id, e.target.value)
          }
          placeholder="Enter Code"
        />
      ),
      width: "120px",
    },
    {
      name: "Material Description",
      selector: (row) => row.materialLongText || "--",
      wrap: true,
      grow: 2,
    },
    {
      name: "Quantity",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="quantity"
          value={row.quantity || ""}
          onChange={(e) =>
            handleInputChange(blockIndex, row.local_id, e, "Number")
          }
        />
      ),
      width: "100px",
    },
    {
      name: "Piece Meas.",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="pieceMeasurement"
          value={row.pieceMeasurement || ""}
          onChange={(e) =>
            handleInputChange(blockIndex, row.local_id, e, "Number")
          }
        />
      ),
      width: "100px",
    },
    {
      name: "Unit / Weight",
      cell: (row) => (
        <div>
          <p style={{ fontWeight: "bold", margin: 0 }}>{row.uOM || "--"}</p>
          <p style={{ margin: 0 }}>{row.unitWeight || "--"}</p>
        </div>
      ),
      width: "100px",
    },
    {
      name: "Unit Price",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="unitPrice"
          value={row.unitPrice || ""}
          onChange={(e) =>
            handleInputChange(blockIndex, row.local_id, e, "Number")
          }
        />
      ),
      width: "100px",
    },
    { name: "Piece Weight", selector: (row) => row.pieceWeight || "--", width: "100px" },
    { name: "Total Weight", selector: (row) => row.totalWeight || "--", width: "100px" },
    { name: "Price", selector: (row) => row.price || "--", width: "100px" },
    { name: "Total Price", selector: (row) => row.totalPrice || "--", width: "100px" },
    { name: "Unit Value", selector: (row) => row.unitValue || "--", width: "100px" },
    {
      name: "Delete",
      cell: (row) => (
        <button onClick={() => removeProductDetails(blockIndex, row.local_id)}>
          <i className="bi bi-trash text-danger fs-4" />
        </button>
      ),
      width: "100px",
    },
  ];
// eslint-disable-next-line
  const [formInputs, setFormInputs] = useState();
  const [modalShow, setModalShow] = useState(false);

  const addProductDetails = (blockIndex) => {
    setActiveBlockIndex(blockIndex);
    setModalShow(true);
  };
  const hideModal = () => {
    setModalShow(false);
    setActiveBlockIndex(null);
  };

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <h2 className="mainTitle">Estimate Creation</h2>
            <p className="subText">Estimate Creation</p>
            <hr />

            {/* Block chooser */}
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <select
                value={selectedOption}
                onChange={handleChange}
                style={{ width: "200px", textAlignLast: "center" }}
                className="form-select"
              >
                <option value="">-- Select an option --</option>
                {options.map((opt, index) => (
                  <option key={index} value={opt}>
                    {opt}
                  </option>
                ))}
              </select>

              <button className="btn btn-primary" onClick={handleAddBlock}>
                Add
              </button>
            </div>
     {/* job no */}
            <div className="d-flex justify-content-end mt-2">
              <table className="table table-bordered table-sm text-center align-middle mb-3">
                <tbody>
                  <tr>
                    <td className="text-start fw-bold">Quote No.</td>
                    <td>
                      <InputField
                        type="text"
                        className="form-control form-control-sm"
                        name="quoteNo"
                        value={formInputs?.quoteNo}
                        onChange={handleChange}
                      />
                    </td>

                    <td className="fw-bold">DSGN</td>
                    <td>
                      <InputField
                        type="text"
                        className="form-control form-control-sm"
                        name="dsgn"
                        value={formInputs?.dsgn}
                        onChange={handleChange}
                      />
                    </td>

                    <td className="fw-bold">CHK</td>
                    <td>
                      <InputField
                        type="text"
                        className="form-control form-control-sm"
                        name="chk"
                        value={formInputs?.chk}
                        onChange={handleChange}
                      />
                    </td>

                    <td className="fw-bold">Date</td>
                    <td>
                      <InputField
                        type="date"
                        className="form-control form-control-sm"
                        name="date1"
                        value={formInputs?.date1}
                        onChange={handleChange}
                      />
                    </td>

                    <td className="fw-bold">REV. No.</td>
                    <td>
                      <InputField
                        type="text"
                        className="form-control form-control-sm"
                        name="revNo"
                        value={formInputs?.revNo}
                        onChange={handleChange}
                      />
                    </td>

                    <td className="fw-bold">Date</td>
                    <td>
                      <InputField
                        type="date"
                        className="form-control form-control-sm"
                        name="date2"
                        value={formInputs?.date2}
                        onChange={handleChange}
                      />
                    </td>
                  </tr>

                  <tr>
                    <td className="text-start fw-bold">Job No.</td>
                    <td>
                      <InputField
                        type="text"
                        className="form-control form-control-sm"
                        name="jobNo"
                        value={formInputs?.jobNo}
                        onChange={handleChange}
                      />
                    </td>
                    <td className="fw-bold">Customer Name</td>
                    <td>
                      <InputField
                        type="text"
                        className="form-control form-control-sm"
                        name="customerName"
                        value={formInputs?.customerName}
                        onChange={handleChange}
                      />
                    </td>
                    <td className="fw-bold text-start">Project Name</td>
                    <td>
                      <InputField
                        type="text"
                        className="form-control form-control-sm"
                        name="projectName"
                        value={formInputs?.projectName}
                        onChange={handleChange}
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            {/* Blocks */}
            <div className="accordion sri-venkateshwara mt-2" id="accordionExample">
              {blocks.map((block, blockIndex) => (
                <div className="accordion mb-4" key={block.id}>
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                          <i
                            className={`bi ${
                              block.isVisible ? "bi-chevron-down" : "bi-chevron-right"
                            }`}
                            onClick={() => toggleBlockVisibility(blockIndex)}
                          ></i>
                        </Col>
                        <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                          <span className="iconLogo">EM</span>
                        </Col>
                        <Col xs={8} md={4} lg={4}>
                          <span className="headerTitle">{block.title}</span>
                          <span className="subHeaderTitle">Estimate Creation Details</span>
                        </Col>

                        <Col xs={12} md={6} lg={6} className="headerButtonAlign">
                          <Col xs={4} md={2} lg={2}>
                            <button className="btnTable" onClick={() => addEmptyRow(blockIndex)}>
                              +
                            </button>
                          </Col>
                          <Col xs={4} md={2} lg={2}>
                              <button
                              className="btnTable"
                              onClick={() => addProductDetails(blockIndex)}
                            >
                              <i className="bi bi-plus-lg"></i> Add
                            </button>
                          </Col>
                          {/* <Col xs={4} md={2} lg={2} className="headerButtonAlign">
                            <button
                              className="btnTable"
                              onClick={() => addProductDetails(blockIndex)}
                            >
                              <i className="bi bi-plus-lg"></i> Add
                            </button>
                          </Col> */}
                        </Col>
                      </Row>
                    </h2>
                    <div className={`accordion-collapse collapse show ${isCardVisible6 ? "visible" : ""}`}>
                      <div className="accordion-body">
                        <Row>
                          <Col xs={12} md={12} lg={12}>
                            <DataTable
                              title=""
                              columns={getProductDetailsCol(blockIndex)}
                              data={block.getProductDetailsData}
                              pagination
                            />
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </Col>
      </Row>

      <Row>
        <Col xs={12} md={{ span: 2, offset: 10 }} lg={{ span: 2, offset: 10 }} className="mb-2">
          <button className="btnTable" onClick={handleCreateManualRFQ} disabled={disabled}>
            Estimate Creation
          </button>
        </Col>
      </Row>

      {/* Modals */}
      <SuccessRegisterModal
        show={getShowSuccessModal}
        onHide={hideSuccessModal}
        modaldata={getModalInfo}
        aftersuccess={Constants.EAUCTION_BUYERAUCTION_LIST}
      />
      <FailureModal
        show={getShowFailureModal}
        onHide={hideFailureModal}
        failuremodaldata={getFailureModal}
        requiredfields={getErrorFields}
      />
      <CommonItemLevelDatatableModal show={false} onHide={() => {}} columns={[]} data={[]} title="" />
      <EstimateModal show={false} onHide={() => {}} clear={true} />
      <EstimateMaterialSelectionModal
        show={modalShow}
        onHide={hideModal}
        onselectedcatdata={(selected) =>
          handleGetSelectedMaterial(selected, activeBlockIndex)
        }
      />
    </main>
  );
};

export default CustomerEstimationE1;
